export enum AccountingListSortProp {
	DisplayId = 'DisplayId',
	AccountingDate = 'AccountingDate',
	DueDate = 'DueDate',
	Amount = 'AmountInvoicing',
	Balance = 'BalanceInvoicing',
}
